import { FC, MouseEventHandler } from "react";
import { Box, Container, Grid, Typography } from "@material-ui/core";
import useStyles from "../styles";

interface OptionProps {
  header: string;
  description: string;
  bdColor: string | undefined;
  onSelectOption: MouseEventHandler<HTMLElement>;
  description2: string | undefined;
  cypressHeaderId?: string | undefined;
  cypressDescriptionId?: string | undefined;
}

const Option: FC<OptionProps> = ({
  header,
  description,
  onSelectOption,
  bdColor,
  description2,
  cypressHeaderId,
  cypressDescriptionId
}) => {
  const styles = useStyles();
  return (
    <Grid item xs={12} sm={12} md={6}>
      <Container>
        <Box
          className={styles.option}
          style={{ border: `1px solid ${bdColor}` }}
          onClick={onSelectOption}
        >
          <Typography className={styles.boxHeader} data-cy={cypressHeaderId}>{header}</Typography>
          <Typography className={styles.boxDescription} data-cy={cypressDescriptionId}>
            {description}
          </Typography>
          {description2 !== undefined && (
            <Typography>
              <li className={styles.boxDescription}>{description2}</li>
            </Typography>
          )}
        </Box>
      </Container>
    </Grid>
  );
};

export default Option;
